import React from "react";
import { AbilityContext } from "../acl/can";
import { canAdvancedOccurrence } from "./occurrenceAdvanced";

export default function withOccurrenceAdvanced(WrappedComponent) {
  return function OccurrenceAdvancedGate(props) {
    return (
      <AbilityContext.Consumer>
        {ability => (
          <WrappedComponent
            {...props}
            occurrenceAdvanced={
              !!(
                ability && ability.can("use module", "diaryOccurrenceAdvanced")
              )
            }
            occurrenceAdvancedAcl={{
              view: canAdvancedOccurrence(ability, "view"),
              create: canAdvancedOccurrence(ability, "create"),
              edit: canAdvancedOccurrence(ability, "edit"),
              delete: canAdvancedOccurrence(ability, "delete")
            }}
          />
        )}
      </AbilityContext.Consumer>
    );
  };
}
